module.exports = __webpack_public_path__ + "img/gudian_new.e45c282a.png";